import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import JsBarcode from "jsbarcode";
import { Printer, ArrowLeft } from "lucide-react";

// Internal, same-domain print page. Barcodes are baked into PNG data-URLs so Chrome Android
// can render the preview reliably (no popup / iframe / auto-closed window).
export default function PrintBarcodes() {
  const navigate = useNavigate();
  const [labels] = useState(() => {
    try { return JSON.parse(sessionStorage.getItem("bc_labels") || "[]"); } catch { return []; }
  });
  const [ready, setReady] = useState(false);

  useEffect(() => {
    let cancelled = false;
    // Convert each barcode to an embedded PNG on a canvas (no live SVG rendering during print).
    document.querySelectorAll("img[data-code]").forEach((img) => {
      const canvas = document.createElement("canvas");
      try {
        JsBarcode(canvas, img.getAttribute("data-code"), { format: "CODE128", width: 1.6, height: 44, fontSize: 12, margin: 4, displayValue: true });
        img.src = canvas.toDataURL("image/png");
      } catch (e) { /* ignore invalid code */ }
    });
    const fontsReady = document.fonts && document.fonts.ready ? document.fonts.ready : Promise.resolve();
    fontsReady.then(() => { if (!cancelled) setTimeout(() => setReady(true), 200); });
    return () => { cancelled = true; };
  }, [labels]);

  return (
    <div className="min-h-screen bg-white" data-testid="print-barcodes-page">
      <div className="no-print sticky top-0 z-10 flex gap-2 p-3 border-b border-[#E2E8F0] bg-white">
        <button className="btn-primary" disabled={!ready || labels.length === 0} onClick={() => window.print()} data-testid="print-do-print">
          <Printer className="w-4 h-4" /> Imprimer
        </button>
        <button className="btn-outline" onClick={() => navigate("/products")} data-testid="print-back-products">
          <ArrowLeft className="w-4 h-4" /> Retour aux produits
        </button>
        {!ready && <span className="text-sm text-[#64748B] self-center" data-testid="print-preparing">Préparation…</span>}
      </div>
      <div className="grid grid-cols-3 gap-1.5 p-2">
        {labels.length === 0 && <div className="col-span-3 text-center text-[#94A3B8] py-10">Aucune étiquette. Retournez aux produits.</div>}
        {labels.map((l, i) => (
          <div key={i} className="border border-[#E2E8F0] rounded-md p-1.5 text-center" style={{ breakInside: "avoid" }}>
            <div className="font-bold text-[11px] text-[#0F172A] leading-tight">{l.name}</div>
            <div className="text-[10px] text-[#475569]">{l.cond}</div>
            <div className="text-[12px] text-[#2563EB] font-bold">{l.priceText}</div>
            <img data-code={l.code} alt={l.code} className="mx-auto" style={{ maxWidth: "100%" }} />
          </div>
        ))}
      </div>
      <style>{`@media print { .no-print { display: none !important; } @page { size: A4; margin: 8mm; } }`}</style>
    </div>
  );
}
